/** Form platform patterns — 28/forms.md */
export const FORM_PATTERN_IDS = ['singleStep', 'wizard', 'modal', 'floor'] as const;

export type FormPatternId = (typeof FORM_PATTERN_IDS)[number];

export const FORM_PATTERN_LABELS: Record<FormPatternId, string> = {
  singleStep: 'Single-step confirm',
  wizard: 'Wizard',
  modal: 'Modal form',
  floor: 'Floor form',
};

export const FORM_PATTERN_MARKERS: Record<FormPatternId, string> = {
  singleStep: 'FP-single-step',
  wizard: 'FP-wizard',
  modal: 'FP-modal',
  floor: 'FP-floor',
};
